import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface AdminActivityEntry {
  id: number;
  admin_user_id: string;
  admin_email: string | null;
  admin_display_name: string | null;
  action: string;
  target_user_id: string | null;
  target_email: string | null;
  target_display_name: string | null;
  action_metadata: Record<string, unknown>;
  created_at: string;
}

/**
 * Global admin activity feed — reverse-chronological AdminAction rows across
 * every user. Use ``beforeId`` to cursor-paginate and ``action`` to filter by
 * action name (e.g. ``delete_user``, ``act_as_start``).
 */
export function useAdminActivity(opts: {
  beforeId?: number;
  action?: string;
  limit?: number;
}) {
  const { beforeId, action, limit = 50 } = opts;
  return useQuery<AdminActivityEntry[]>({
    queryKey: ["admin", "activity", action ?? null, beforeId ?? null, limit],
    queryFn: () => {
      const params = new URLSearchParams();
      params.set("limit", String(limit));
      if (beforeId !== undefined) params.set("before_id", String(beforeId));
      if (action) params.set("action", action);
      return apiClient.get(`api/admin/activity?${params}`).json();
    },
    staleTime: 5_000,
    retry: false,
  });
}
